import { render, staticRenderFns } from "./custom_folder.vue?vue&type=template&id=393ad956&lang=pug"
import script from "./custom_folder.vue?vue&type=script&lang=js"
export * from "./custom_folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports